// extracted by mini-css-extract-plugin
export default {"mainContainer":"core_information_section-module___mainContainer___d88fceb6","infoWrapper":"core_information_section-module___infoWrapper___dfc4fb6e"};